import { fulfillmentApi } from '../../../api/fulfillmentApi';
import { createMaterial, IMaterial } from '../../../models/materials';
import { rows } from '../../../pages/materials/__mock__';
import { AppDispatch, RootState } from '../../store';
import { setMaterials, startLoadingMaterials } from './materialsSlice';

export const getMaterials = () => {
    return async (dispatch: AppDispatch, getState: RootState) => {
        dispatch(startLoadingMaterials());

        const resp = await fulfillmentApi.get(`materials`);
        console.log(resp.data);
        dispatch(setMaterials({ materials: resp.data }));
    }
}
export const saveMaterial = (material: IMaterial) => {
    return async (dispatch: AppDispatch, getState: RootState) => {
        dispatch(startLoadingMaterials());
        //const { data } = await Api.get(`/?limit=10&offset=${ page * 10 }`);
        const newMaterial = createMaterial(material);
        const data = rows.concat(newMaterial);
        dispatch(setMaterials({ materials: data }));
    }
}
export const deleteMaterial = (material: IMaterial) => {
    return async (dispatch: AppDispatch, getState: RootState) => {
        dispatch(startLoadingMaterials());
        //const { data } = await Api.get(`/?limit=10&offset=${ page * 10 }`);
        const data = rows.filter((item) => item.id !== material.id);
        dispatch(setMaterials({ materials: data }));
    }
}